<template>
    <div>
        <modal v-model="evolveTreatmentOrthodonticModal" @hide="resetEvolveTreatmentOrthodonticModal" title="Evolução de tratamento ortodôntico">
            <div class="row">
                <div class="col-lg-12">
                    <div :class="[ $v.evolution.evolution.required ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">Evolução</label>
                        <textarea class="form-control" v-model="evolution.evolution" rows="10" required></textarea>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <btn type="primary" @click="evolveTreatmentOrthodontic" :disabled="btnEvolveTreatmentOrthodontic"><i class="fa fa-save" aria-hidden="true"></i> {{ okTextEvolveTreatmentOrthodonticModal }}</btn>
                <btn @click="evolveTreatmentOrthodonticModal = false">Cancelar</btn>
            </div>
        </modal>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-header with-border">
                        <i class="fa fa-info-circle"></i>
                        <h3 class="box-title">Evolução do tratamento</h3>
                        <btn type="info" style="margin-left: 4px !important;" class="pull-right" @click="addEvolveTreatmentOrthodonticModal"><i class="fa fa-plus" aria-hidden="true" title="Evoluir tratamento ortodôntico"></i> Evoluir tratamento</btn>
                        <btn type="info" class="pull-right" :disabled="!evolutions.length" @click="printOrthodonticEvolutions"><i class="fa fa-print" aria-hidden="true" title="Imprimir evoluções"></i> Imprimir Evoluções</btn>
                    </div>
                    <div class="box-body">
                        <div class="row" v-for="(evolution, i) in evolutions" :key="i" :style="evolution.deleted_at ? 'background-color:#ff8080; padding-left: 5px; color: white' : '' ">
                            <span v-if="evolution.deleted_at">
                                {{ formatDate(evolution.created_at,'dateTime') }} | {{ evolution.dentist && evolution.dentist.name }} <br> 
                                <span v-html="evolution.evolution"></span>
                                <h5>
                                    CANCELADO EM {{formatDate(evolution.deleted_at,'dateTime')}}
                                    <btn type="danger" :disabled="!isAdmin" @click="deleteTrashedEvolution(evolution)" class="pull-right"><i class="fa fa-trash-o" aria-hidden="true" title="Excluir"></i></btn>
                                    <btn type="success" :disabled="!isAdmin" @click="restoreTrashedEvolution(evolution)" class="pull-right"><i class="fa fa-undo" aria-hidden="true" title="Restaurar"></i></btn>
                                </h5>

                            </span>
                            <span v-else>
                                {{ formatDate(evolution.created_at,'dateTime') }} | {{ evolution.dentist && evolution.dentist.name }} <br>
                                <span v-html="evolution.evolution"></span>
                                <div class="row">
                                    <div class="col-md-12 text-right">
                                        <btn type="info" :disabled="!isAdmin" @click="printOrthodonticEvolution(evolution)"><i class="fa fa-print" aria-hidden="true" title="Imprimir"></i></btn>
                                        <btn type="info" :disabled="!isAdmin" @click="editEvolveTreatmentOrthodonticModal(evolution)"><i class="fa fa-pencil" aria-hidden="true" title="Alterar"></i></btn>
                                        <btn type="danger" :disabled="!isAdmin" @click="deleteEvolution(evolution)"><i class="fa fa-ban" aria-hidden="true" title="Cancelar"></i></btn>
                                    </div>
                                </div>
                            </span>
                            <hr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import moment from "moment";

    export default {
        name: "Orthodontics.vue",

        props: {
            patientProp: { type: Object },
            authUser: { type: Object },
        },

        validations: {
            evolution: {
                evolution: { required }
            },
        },
        data () {
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },
                isAdmin: false,
                btnEvolveTreatmentOrthodontic: false,
                evolveTreatmentOrthodonticModal: false,
                patient: this.patientProp,
                evolution: {
                    id: null,
                    evolution: '',
                    patient_id: this.patientProp.id
                },
                evolutions: [],
                okTextEvolveTreatmentOrthodonticModal: ''
            }
        },

        computed: {
            moment() {
                return moment;
            },
        },

        watch: {

        },

        mounted() {
            this.getEvolutions()
            this.isAdmin = this.authUser.roles.filter(r => (r.name === "admin")).length;
        },

        methods: {
            async getEvolutions(){
                try {
                    const response = await axios.post('/treatments/orthodontics/evolution', {patient: this.patient})
                    this.evolutions = response.data
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            printOrthodonticEvolution(evolution) {
                window.open(`/orthodontic/printOrthodonticEvolution/${evolution.id}`, "_blank");
            },

            printOrthodonticEvolutions() {
                window.open(`/orthodontic/printOrthodonticEvolutions/${this.evolution.patient_id}`, "_blank");
            },

            addEvolveTreatmentOrthodonticModal(){
                this.okTextEvolveTreatmentOrthodonticModal = 'Evoluir tratamento ortodôntico'
                this.evolveTreatmentOrthodonticModal = true
            },

            editEvolveTreatmentOrthodonticModal(evolution){
                Object.assign(this.evolution, evolution)
                this.okTextEvolveTreatmentOrthodonticModal = 'Alterar evolução'
                this.evolveTreatmentOrthodonticModal = true
            },

            resetEvolveTreatmentOrthodonticModal(){
                this.evolution = {
                    id: null,
                    evolution: '',
                }
            },

            async evolveTreatmentOrthodontic(){
                if (this.$v.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }
                this.btnEvolveTreatmentOrthodontic = true
                try {
                    let response = {}
                    if(this.evolution.id) response = await axios.put('/evolution/treatment',{ evolution: this.evolution, patient_id: this.patient.id })
                    else response = await axios.post('/treatment/evolve',{ evolution: this.evolution.evolution, patient_id: this.patient.id })

                    if(response.data.type == 'success'){
                        await this.getEvolutions()
                        this.evolveTreatmentOrthodonticModal = false
                        this.btnEvolveTreatmentOrthodontic = false
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                        this.btnEvolveTreatmentOrthodontic = false
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                        this.btnEvolveTreatmentOrthodontic = false
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                        this.btnEvolveTreatmentOrthodontic = false
                    } else {
                        this.btnEvolveTreatmentOrthodontic = false
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            deleteEvolution(data) {
                let self = this;
                this.$toast.question('Tem certeza que deseja cancelar esta evolução?','ATENÇÃO',{
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>CANCELAR EVOLUÇÃO</b></button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                                axios.delete('/evolutionTreatment/remove/' + data.id)
                                    .then(async response => {
                                        if(response.data.type == 'success'){
                                            await self.getEvolutions()
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if(response.data.type == 'warning'){
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if(error.response.status === 401 || error.response.status === 419){
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>FECHAR</button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                            }
                        ]
                    ],
                })
            },

            deleteTrashedEvolution(data){
                let self = this;
                this.$toast.question('Tem certeza que deseja excluir definitiamente esta evolução?<br>Esta operação é IRREVERSÍVEL!','ATENÇÃO',{
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>DELETAR EVOLUÇÃO</b></button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                                axios.delete('/evolutionTreatment/remove/' + data.id + '/force')
                                    .then(async response => {
                                        if(response.data.type == 'success'){
                                            await self.getEvolutions()
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if(response.data.type == 'warning'){
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if(error.response.status === 401 || error.response.status === 419){
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>CANCELAR</button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                            }
                        ]
                    ],
                })
            },

            async restoreTrashedEvolution(data){
                try {
                    const response = await axios.put('/evolutionTreatment/restore/' + data.id)

                    if(response.data.type == 'success'){
                        await this.getEvolutions()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            formatDate(dateTimeString = null, type = 'date') {
                if(dateTimeString) {
                    if(type == 'date'){ // A data passada deve estar no padrão: YYYY-MM-DD
                        const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
                        return `${DD}/${MM}/${YYYY}`;
                    } else if(type == 'time'){
                        return dateTimeString
                    } else if(type == 'dateTime'){ // A data passada deve estar no padrão: YYYY-MM-DD HH:mm:ss
                        const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
                        const [H, m, s] = (dateTimeString.slice(11,19)).split(':');
                        return `${DD}/${MM}/${YYYY} ${H}:${m}:${s}`;
                    }
                    return dateTimeString

                    // // DD/MM/YYYY HH:mm:ss
                    // // Primeiro, dividimos a data completa em duas partes:
                    // const [date, time] = dateTimeString.split(' ');
                    //
                    //
                    // // Dividimos o tempo em hora e minutos:
                    // const [HH, mm, ss] = time.split(':');
                    //
                    // // Retornamos a data formatada em um padrão compatível com ISO:
                    // return `${DD}/${MM}/${YYYY}T${HH}:${mm}:${ss}`;
                }
                return '';
            },
        }
    }
</script>

<style scoped>

</style>